import moment, { type Moment } from 'moment';

/** A licence period from the backend account payload. */
export interface Licence {
  /** Inclusive start of the licence period (anything moment can parse). */
  start: string | Date;
  /** Exclusive end of the licence period (anything moment can parse). */
  end: string | Date;
  [key: string]: any;
}

const LicenceUtil = {
  /**
   * Picks the licence active at `date` (start ≤ date < end).
   * @param licences all licence periods of the account
   * @param date point in time to evaluate; defaults to now
   * @returns the matching licence, or false when none is active (historical API — not null)
   */
  currentLicence(licences: Licence[] = [], date: Moment = moment()): Licence | false {
    let current: Licence | false = false;
    licences.forEach((l) => {
      if (date.isSameOrAfter(l.start) && date.isBefore(l.end)) {
        current = l;
      }
    });
    return current;
  },
};

export default LicenceUtil;
